import React from 'react'
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | GeoID</title>
      </Helmet>
      <div className='main-container'>
        <div className="section-heading">
          <h1>Privacy Policy</h1>
        </div>
        <div className="section">
          <p className="para-content">Geoportal of Indian Dams does not automatically capture any specific personal information from you, (like name, phone number or e-mail address), that allows us to identify you individually.
          </p>

          <p className="para-content">

            Email Management: Your email address will only be recorded if you choose to send a message. It will only be used for the purpose for which you have provided it and will not be added to a mailing list. Your email address will not be used for any other purpose, and will not be disclosed, without your consent.
          </p>

          <p className="para-content">
            We do not sell or share any personally identifiable information volunteered on the portal to any third party (public/private).
          </p>

          <p className="para-content">
            Any information provided to this portal will be protected from loss, misuse, unauthorized access or disclosure, alteration, or destruction.
          </p>
        </div>
      </div>
    </>
  )
}

export default PrivacyPolicy
